import { useQuery } from "@tanstack/react-query";
import { useZohoAuthContext } from "context/ZohoAuthContext";
const STALE_TIME = 60 * 60 * 1000; // 1 hour

export const useModuleArray = () => {
  const { initZoho } = useZohoAuthContext();
  const {
    isFetching,
    data: moduleArray,
    isError,
    error,
  } = useQuery({
    queryKey: ["moduleArray"],
    staleTime: STALE_TIME,
    enabled: initZoho,
    queryFn: async () => {
      const resp = await window.ZOHO.CRM.META.getModules();
      const respOrg = await window.ZOHO.CRM.CONFIG.getOrgInfo();
      const data = resp?.modules?.filter((obj) => obj?.api_supported && obj?.quick_create);
      const domainName = await respOrg.org?.[0]?.domain_name;
      const arr = data?.map(({ id, api_name, module_name, plural_label, ...rest }, index) => {
        const url_with_org_domain = `https://crm.zoho.com/crm/${domainName}/tab/${module_name}/`;

        return {
          id,
          api_name,
          plural_label,
          url_with_org_domain,
        };
      });

      return arr;
    },
  });
  return moduleArray;
};
